import { defineRule } from '../define-rule'
import type { BaseRuleConstructorParams } from '../ts/rule-constructor-parameter.type'

export type EmailRuleConstructorParams = BaseRuleConstructorParams<undefined>

// This regular expression validates an email address by checking
// 1. The local part (username) which can include letters, numbers, periods, underscores, plus signs, or dashes, but cannot contain spaces, brackets, or other special characters unless enclosed in quotes.
// 2. An "@" symbol separating the local part from the domain.
// 3. The domain, which can be either an IPv4 address in square brackets or a standard domain name with allowed characters and proper structure.
const emailValidationPattern =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const email = defineRule('email', ({ errorMessage }: EmailRuleConstructorParams) => {
  return (value: string) => emailValidationPattern.test(value) || (errorMessage ?? false)
})
